
// Define the content type options
export const CONTENT_TYPE_OPTIONS = [
  'Twitter - QT', 'Twitter - Tweet', 'Twitter - RT', 'Twitter - Thread/long post',
  'Telegram - post', 'Youtube - full video', 'Youtube - integration', 
  'Naver - Blog', 'Blogs or News', 'PR', 'AMA', 'Others'
];

export const PLATFORM_OPTIONS = ['Telegram', 'Youtube', 'Blog', 'Twitter'];

export const TYPE_OPTIONS = [
  'Twitter - QT', 'Twitter - Tweet', 'Twitter - RT', 'Twitter - Thread/long post',
  'Telegram - post', 'Youtube - full video', 'Youtube - integration', 
  'Naver - Blog', 'Blogs or News', 'PR', 'AMA', 'Others'
];

export const POST_TYPE_OPTIONS = ['Airdrop', 'Defi', 'General', 'GameFi', 'News'];

export const TIER_OPTIONS = ['Tier 0', 'Tier 1', 'Tier 2', 'Tier 3'];

export const LANGUAGE_OPTIONS = ['CN', 'DE', 'EN', 'ES', 'ID', 'IN', 'IT', 'JP', 'KR', 'PH', 'RU', 'TR', 'VN'];
